import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InvoiceArticle } from 'src/modules/invoice/models/invoiceArticle';
import { AutocompleteDropdown } from 'src/shared/components/form/autocompleteDropdown';

type TicketArticlePickerProps = {
  index: number;
  invoiceArticles: InvoiceArticle[];
};
export const TicketArticlePicker = (props: TicketArticlePickerProps) => {
  const { index, invoiceArticles } = props;
  const { t } = useTranslation();
  const { setValue, watch } = useFormContext();

  const selectedId = watch(`tickets.${index}.invoiceArticleId`) as number | null | undefined;

  const selectedArticle = useMemo(() => invoiceArticles.find((x) => x.article_id === selectedId) ?? null, [invoiceArticles, selectedId]);

  return (
    <AutocompleteDropdown<InvoiceArticle>
      options={invoiceArticles || []}
      nameProp='name'
      keyProp='article_id'
      name={`tickets.${index}.invoiceArticleId`}
      value={selectedArticle}
      emptyLabel={t('invoice:createInvoce.selectArticle')}
      placeholder={t('invoice:createInvoce.selectArticle')}
      label={t('invoice:createInvoice.invoiceRow.articleName')}
      callback={(val: InvoiceArticle | null) => {
        if (val) {
          setValue(`tickets.${index}.invoiceArticleId`, val.article_id);
        } else {
          setValue(`tickets.${index}.invoiceArticleId`, null);
        }
      }}
      componentWidth='100%'
    />
  );
};
